// A car's connections as its TUNE MFD names them: each kind of device, and the configs a connection names (by ID, or
// an older config's file). Kept apart from car-values.ts, which reads configs, so a page that only names them (a car's
// Connections) doesn't load the config reader.

/**
 * TUNE's configs' old names, before they had IDs: the configs that took their place (TUNE Live's connections.md, and
 * its decision D-119). An edited copy of the old file on an MFD is beyond what the web can see.
 */
export const RENAMED: Readonly<Record<string, string>> = {
  'builtin:haltech': 'c5002ae1-a72a-4cd0-ada2-7dc04b7637dc',
  'haltech_v4_can.xml': 'c5002ae1-a72a-4cd0-ada2-7dc04b7637dc',
  'Link Display.xml': '84f68437-38d1-4ecf-adee-57c356cc6a79',
};

/** The ID of the config a connection's entry names. */
export function configIdOf(entry: string): string {
  return (RENAMED[entry] ?? entry).toLowerCase();
}

/** What each kind of connection is called on the MFD. */
export const DEVICES: Readonly<Record<string, string>> = {
  canbox: 'Tune CANBOX',
  obd2: 'OBD2 adapter',
  consult: 'Nissan Consult',
  hondata: 'Hondata',
  aem: 'AEM',
};
